module.exports = __webpack_public_path__ + "static/face-195b61ea67f45687a3e843848f367a4e.jpg";